import { Component, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-kpi-card',
  imports: [CardModule, ButtonModule],
  templateUrl: './kpi-card.html',
  styleUrl: './kpi-card.scss'
})
export class KpiCard {
  readonly title = input<string>('');
  readonly value = input<number | null>(null);
  readonly icon = input<string>('');
  readonly color = input<string>('primary');
  readonly loading = input<boolean>(false);
  readonly ctaLabel = input<string>('');
  readonly ctaIcon = input<string>('');
  readonly ctaClick = output<void>();
}
